<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="搜索條件">
            <el-select v-model="searchBlock" placeholder="請選擇">
              <el-option label="用戶賬號" value="1"></el-option>
              <el-option label="用戶暱稱" value="2"></el-option>
              <el-option label="違規次數" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="關鍵字">
            <el-input
              v-model="listMenuForm.keyword"
              placeholder="請輸入搜索內容"
              @input="numberFn"
            ></el-input>
          </el-form-item>
          <el-form-item label="檢舉類型">
            <el-select v-model="typeNameValue" placeholder="請選擇">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(data, index) in typeNameArray"
              style="width: 200px;" 
              :key="index" :label="data.name" :value="data.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="狀態">
            <el-select v-model="statusBlock" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="已違規" value="1"></el-option>
              <el-option label="已解禁" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="MenuBtnWrap">
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap mergeTable">
        <el-table
          :data="goodsList"
          border
          height='660px'
          style="width:100%;"
          @sort-change="handleSortChange"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in complainsTable" :key="index"
            :prop="item.prop"
            :sortable="item.sortable"
            :label="item.label"
            :width="item.width">
            <template slot-scope="scope">
              <div v-if="item.prop === 'complainsType'">
                <el-tooltip v-if="scope.row.complainsTypeList.length > 1" placement="top">
                  <div slot="content">
                    <p v-for="(items, childIndex) in scope.row.complainsTypeList" :key="childIndex">
                        {{ items }}{{ childIndex === scope.row.list.length - 1 ? '' : '、' }}
                    </p>
                  </div>
                  <div>
                    <p v-for="(items, childIndex) in scope.row.complainsTypeList" v-if="childIndex === 0 || childIndex === 1" :key="childIndex">
                        {{ items }}{{ childIndex === 0 ? '、' : '' }}
                    </p>
                    等
                  </div>
                </el-tooltip>

                <div v-else>
                  <p v-for="(items, childIndex) in scope.row.complainsTypeList" :key="childIndex">
                      {{ items }}
                  </p>
                </div>
              </div>

              <div v-else-if="item.prop === 'complainsUsers'">
                <el-tooltip v-if="scope.row.list.length > 1" placement="top">
                  <div slot="content" style="max-width: 1000px;">
                    <span v-for="(items, childIndex) in scope.row.list" :key="childIndex">
                        {{ items.nickname }}{{ childIndex === scope.row.list.length - 1 ? '' : '、' }}
                    </span>
                  </div>
                  <div>
                    <p v-for="(items, childIndex) in scope.row.list" v-if="childIndex === 0 || childIndex === 1" :key="childIndex">
                        {{ items.nickname }}{{ childIndex === 0 ? '、' : '' }}
                    </p>
                    等多位用戶
                  </div>
                </el-tooltip>

                <div v-else>
                  <p v-for="(items, childIndex) in scope.row.list" :key="childIndex">
                      {{ items.nickname }}
                  </p>
                </div>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="160">
            <template slot-scope="scope">
              <el-button
                class="topBtn"
                @click="unbanAccount(scope.row)"
                :disabled="scope.row.status == '已解禁'"
                type="text"
              >解禁</el-button>
              <el-button
                class="topBtn"
                @click="blackUser(scope.row.userId, scope.row.username, 1)"
                :disabled="scope.row.blackList > 0"
                type="text"
              >加入黑名單</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!--加入黑名单-->
    <div v-if="addBlackFlag" class="propWrap">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <!---->
            <span class="prop-title">提示信息</span>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
              @click="cancelAddBlack"
            ></i>
          </button>
        </div>
        <div class="el-message-box__content" style="display:block;">
          <div class="el-message-box__message" style="margin-bottom:0.2rem;">
            <p>{{ addBlacktips }}</p>
          </div>
          <el-form>
            <el-form-item label="禁用功能 ：">
              <el-checkbox-group
                v-model="checkBlackList"
                @change="handleCheckedTypeChange"
              >
                <el-checkbox :label="1">登錄</el-checkbox>
                <el-checkbox :label="2">新聞評論</el-checkbox>
                <el-checkbox :label="5">活动报名</el-checkbox>
                <el-checkbox :label="7">粉絲發信</el-checkbox>
                <!-- <el-checkbox :label="3">發帖</el-checkbox>
                <el-checkbox :label="4">社區評論</el-checkbox> -->
              </el-checkbox-group>

              <!-- <el-radio-group v-model="blackType">
                  <el-radio :label="1">登錄</el-radio>
                  <el-radio :label="2">發言</el-radio>
              </el-radio-group> -->
            </el-form-item>
            <el-form-item label="禁用至 ：">
              <el-date-picker
                :picker-options="forbiddenOptions"
                v-model="downTime"
                type="datetime"
                @change="handleForbidTime"
                placeholder="選擇時間"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input
                type="textarea"
                autosize
                placeholder="請輸入加入黑名單原因"
                v-model="blackReason"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-message-box__btns">
          <button
            @click="cancelAddBlack"
            type="button"
            class="el-button el-button--default el-button--small"
          >
            <span>取消</span>
          </button>
          <button
            @click="addBlack(addBlackId, addBlackEmail)"
            type="button"
            class="el-button el-button--default el-button--small el-button--primary "
          >
            <span>確認</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';

export default {
  data () {
    return {
      navBlock: '會員',
      navtitle: '賬號檢舉',
      goodsList:[],
      searchBlock: '1',
      statusBlock: '',
      listMenuForm: {
        keyword: "",
      },
      complainsTable: [
        {
          prop: 'username',
          label: '用戶賬號',
          width: ''
        },{
          prop: 'nickname',
          label: '用戶暱稱',
          width: ''
        },{
          prop: 'complainsType',
          label: '檢舉類型',
          width: '',
        },{
          prop: 'complainsUsers',
          label: '檢舉人',
          width: '100',
        },{
          prop: 'complaintNum',
          label: '檢舉次數',
          width: '100',
          sortable: "custom"
        }, {
          prop: 'illegalNum',
          label: '違規次數',
          width: '100',
          sortable: "custom"
        }, {
          prop: 'status',
          label: '狀態',
          width: '80'
        }, {
          prop: 'complaintTime',
          label: '檢舉時間',
          width: ''
        }
      ],
      total: 0,
      currentPage: 1,
      typeNameArray: [
        {name: '企圖破壞或入侵信息', type: 100},
        {name: '發佈謾罵、攻擊性言論、侮辱等不當言論', type: 101},
        {name: '進行非法交易行為', type: 102},
        {name: '冒充平台或其他用戶身份', type: 103},
        {name: '侵犯他人知識產權或其他合法權益', type: 104},
        {name: '故意干擾或破壞平台相關功能', type: 105},
        {name: '違法或犯罪行為', type: 106},
        {name: '其他危害行為', type: 107},
      ],
      typeNameValue: '',
      complaintSortValue: '',
      illegalSortValue: '',
      addBlackFlag: false, // 加入黑名单弹窗
      addBlackId: "",
      addBlackEmail: "",
      blackReason: "", //黑名單原因
      blackType: 1,
      checkBlackList: [],
      downTime: "", //禁用VIP到期時間
      forbiddenOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000; // 限制只可以选择今天及今天之前的日期
        }
      },
    }
  },
  created(){
    this.initList();
  },
  activated(){
    if(this.currentPage===1){
      this.initList();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  watch: {
    searchBlock(newValue, oldValue) {
      this.listMenuForm.keyword = '';
    }
  },
  methods:{
    // 初始化商品列表
    initList(){
        let usernameValue = this.searchBlock == '1' ? this.listMenuForm.keyword : '';
        let nicknameValue = this.searchBlock == '2' ? this.listMenuForm.keyword : '';
        let illegalNumValue = this.searchBlock == '3' ? this.listMenuForm.keyword : '';
        let statusValue = this.statusBlock ? Number(this.statusBlock) : '';
        let complaintTypeValue = Number(this.typeNameValue) > 99 ? Number(this.typeNameValue) : ''
      this.$get(`/request/complains/user/list?page=${this.currentPage}&size=10&username=${usernameValue}&nickname=${nicknameValue}&illegalNum=${illegalNumValue}&status=${statusValue}&complaintType=${complaintTypeValue}&complaintSort=${this.complaintSortValue}&illegalSort=${this.illegalSortValue}`, this.$GLOBAL.jsonConfig)
      .then((res) => {
        // console.log(res);
        if(res.code==='00000') {
          res.data.list.forEach(v => {
            v.complaintTime = v.complaintTime ? this.$getTime(v.complaintTime) : '-';
            v.username = v.username ? v.username : '-';
            v.nickname = v.nickname ? v.nickname : '-';
            switch (v.status) {
              case 0:
                v.status = '已解禁'
                break
              case 1:
                v.status = '已違規'
                break
            }
          });
          this.goodsList = res.data.list;
          this.total = res.data.allRow;
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            center: true
          });
        }
      })
    },
    //需要跨页全排，前端做不了要后端支持
    handleSortChange({ column, prop, order }) {
      if (prop == "complaintNum") {
        this.illegalSortValue = "";
        if (order == "ascending") {
          //升序
          this.complaintSortValue = 0;
        } else if (order == "descending") {
          //降序
          this.complaintSortValue = 1;
        } else {
          this.complaintSortValue = "";
        }
      } else if (prop == "illegalNum") {
        this.complaintSortValue = "";
        if (order == "ascending") {
          //升序
          this.illegalSortValue = 0;
        } else if (order == "descending") {
          //降序
          this.illegalSortValue = 1;
        } else {
          this.illegalSortValue = "";
        }
      };

      this.initList();
    },
    // 正则判断输入框只能输入数字
    numberFn(num) {
      if (this.searchBlock === '3') {
        if (!/^\d*$/.test(num)) {
            this.listMenuForm.keyword = num.replace(/\D/g, '');
        }
      }
    },
    //数据数量选择
    handleCurrentChange(val){
      this.currentPage = val;
      this.initList();
    },
    // 查询
    search() {
      this.currentPage = 1;
      this.initList();
    },
    // 重置
    reset() {
      this.currentPage = 1;
      this.searchBlock = '1';
      this.listMenuForm.keyword = '';
      this.statusBlock = '';
      this.typeNameValue = '';
      this.initList();
    },
    // 初始/作廢
    unbanAccount(row) {
      let noticeContent = '';
      let message = '';
      noticeContent = `是否解禁用戶：${row.username}，解禁後用戶可正常進行互動`;
        message = '解禁成功';

        this.$confirm(noticeContent, {
          showClose: false,
          closeOnClickModal: false
        })
        .then(() => {
          let params = {
            userId: row.userId,
          }
          this.$post('/request/complains/user/lift', params, this.$GLOBAL.jsonConfig)
          .then(res => {
            // console.log(res)
            if (res.code === '00000') {
              this.$message({
                message: message,
                type: 'success',
                center: true
              });
              this.initList();
            } else {
              this.$message({
                message: res.message,
                type: 'error',
                center: true
              });
            }
          })
        })
    },
    // 限制禁用时间只能是当前时间之后
    handleForbidTime() {
      var startAt = (new Date(this.downTime) * 1000) / 1000;
      if (startAt < Date.now()) {
        this.downTime = new Date();
      }
    },
    handleCheckedTypeChange(value) {
      console.log(value);
    },
    //將用戶加入黑名單
    blackUser(id, email, flag) {
      let _this = this;
      let tipText = "";
      let successText = "";
      _this.checkBlackList = [];
      _this.downTime = "";
      _this.blackReason = "";
      if (flag === 1) {
        _this.addBlackFlag = true;
        _this.addBlackId = id;
        _this.addBlackEmail = email;
        _this.addBlacktips = `是否將賬號為${email}的用戶加入黑名單，加入後，用戶將無法用此賬號登錄或註冊，詳情可以在黑名單列表中查看`;
      } else if (flag === 0) {
        tipText = `是否將賬號為${email}的用戶移出黑名單，移出後，用戶將正常使用該賬戶所有功能`;
        successText = "將用戶移出黑名單成功，請稍後~";
        _this
          .$confirm(tipText, "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            // flag為1則為黑名單用戶，0反之
            _this
              .$get(
                `/request/member/addBlackList?id=${id}&blackListDetails=&flag=${flag}&email=${email}`,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage(successText, "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          })
          .catch(() => {});
      }
    },
    cancelAddBlack() {
      this.addBlackFlag = false;
      this.checkBlackList = [];
      this.blackReason = "";
      this.downTime = "";
    },
    addBlack(id, email) {
      let _this = this;
      if (_this.blackReason !== "" && _this.$getCaption(_this.blackReason)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "加入黑名單原因不能包含非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );

        return false;
      }
      if (_this.downTime === "" || _this.downTime === null) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇禁用到期時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      let param = {
        userId: id,
        blackList:
          _this.checkBlackList.length === 1
            ? _this.checkBlackList[0]
            : _this.checkBlackList.join(","),
        blackListContent: _this.blackReason,
        downTime: _this.$formatDate(_this.downTime)
      };
      if (_this.checkBlackList.length == 0) {
        param.blackList = "6";
      }
      _this
        .$put(
          `request/blackMember/saveBlackList`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.$message({
              message: '將用戶加入黑名單成功',
              type: 'success',
              center: true
            });
            _this.dialogVisible = false;
            _this.addBlackId = "";
            _this.addBlackEmail = "";
            _this.addBlackFlag = false;
            _this.blackReason = "";
            _this.initList();
          } else {
            _this.$message({
              message: res.message,
              type: 'error',
              center: true
            });
            _this.dialogVisible = false;
          }
        });
    },
  },
  components: {
    NavBar,
  }
};
</script>
<style lang="less" scoped>

  .content{

    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        .goodsOperate{
          display: inline-block;
          img{
            width: 0.16rem;
          }
        }
        .goodsOperate:last-child{
          margin-left: 0.2rem;
        }


        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
        @media (min-width: 769px) {
          .downShelf{
            width: 0.8rem;
            padding-left: 0.2rem;
            background:url('../../../assets/images/market/downShelf.png') no-repeat center left;
          }
          .onShelves{
            width: 0.8rem;
            padding-left: 0.2rem;
            background: url('../../../assets/images/market/onShelves.png') no-repeat center left;
          }
        }
      }
    }

    .propWrap{
      .icon-close{
        margin:10px;
      }
      .detailsContent{
        width: 100%;
        padding: 0.5rem;
        min-height: 0;
      }
    }

  }
  @media screen and (min-width: 769px) {
    .ListMenu{
      display: flex;
      justify-content: space-between;
      .searchForm{
        flex: 1;
        display: flex;
        justify-content: flex-start;
      }
      .MenuBtnWrap{
        flex: 1;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/user/account/reportList.vue